import { css } from 'lit';

import { typography, ml } from '../../styles';
import color from '../../utils/get-color-token';
import token from '../../utils/get-token';

function styles() {
	return [
		css`
			:host {
				display: flex;
				align-items: center;
				justify-content: flex-start;
				gap: ${token('spacing-0-5')};
			}

			.label {
				${typography('body-md')};

				display: inline-flex;
				align-items: center;
				justify-content: flex-start;

				margin: 0;
				padding: 0;

				color: ${color('color-text-tertiary')};
			}

			.required {
				${typography('body-md')};

				color: ${color('color-text-error')};

				content: '*';

				${ml(token('spacing-1'))};
			}

			.label.-size-small,
			.label.-size-small .required {
				${typography('body-sm')};
			}
		`,
	];
}

export default styles;
